import { Image, Row } from "react-bootstrap";

export const rulesViewNavbar = (route) => {
  const urlRef = route.split("/");
  const firstURLElement = urlRef[1];
  const lastURLElement = urlRef.pop();
  let isShowNavTop = false;
  let isShowNavHeader = true;
  let isShowNavFooter = true;
  let haveExceptionalHeader = false;
  let ExceptionalHeader = <></>;
  let isFluid = false;

  switch (lastURLElement) {
    case "auth":
      isShowNavTop = false;
      isShowNavHeader = false;
      isShowNavFooter = false;
      break;
    case "delete-account":
      isShowNavTop = false;
      isShowNavHeader = false;
      isShowNavFooter = false;
      break;
    case "recovery-access":
      isShowNavTop = false;
      isShowNavHeader = false;
      isShowNavFooter = false;
      break;
    case "signup":
      isShowNavTop = false;
      isShowNavHeader = false;
      isShowNavFooter = false;
      break;
    case "subscription":
      isShowNavHeader = false;
      haveExceptionalHeader = true;
      ExceptionalHeader = (
        <Row className="" style={{ marginTop: -23 }}>
          <Image src="assets/3fb0bb03-e0de-49a2-948b-7c06f5cdc385.jpg" fluid />
        </Row>
      );
      break;

    default:
      break;
  }

  switch (firstURLElement) {
    case "adm":
      isShowNavTop = false;
      isShowNavHeader = false;
      isShowNavFooter = false;
      isFluid = true;
      break;

    default:
      break;
  }

  return {
    isShowNavTop: isShowNavTop,
    isShowNavHeader: isShowNavHeader,
    isShowNavFooter: isShowNavFooter,
    haveExceptionalHeader: haveExceptionalHeader,
    ExceptionalHeader: ExceptionalHeader,
    isFluid,
  };
};
